import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { KindOfLoader } from '../../../models';

@Component({
  selector: 'shared-loader',
  standalone: false,
  template: `@if (isLoading && kindOfLoader === 'secondary') {
    <div class="loader-container">
      <div class="loader {{ secondaryLoaderDotGap || 'gap-2' }}">
        <div class="dot {{ secondaryLoaderDotSize }}"></div>
        <div class="dot {{ secondaryLoaderDotSize }}"></div>
        <div class="dot {{ secondaryLoaderDotSize }}"></div>
      </div>
    </div>
    } @if (isLoading && kindOfLoader === 'primary') {
    <div
      class="fixed z-[99999] h-screen w-full top-0 left-0 grid place-items-center"
    >
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
    } @if (isLoading && kindOfLoader === 'spinner') {
    <span class="spinner-loader {{ secondaryLoaderDotSize }}"></span>
    }`,

  styles: `.spinner {
    animation: rotator 1.4s linear infinite;
    z-index: 9999999;
  }
  
  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(270deg);
    }
  }
  
  .path {
    stroke-dasharray: 187;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
  }
  
  @keyframes colors {
    0% {
      stroke: #4285f4;
    }
  
    25% {
      stroke: #de3e35;
    }
  
    50% {
      stroke: #f7c223;
    }
  
    75% {
      stroke: #1b9a59;
    }
  
    100% {
      stroke: #4285f4;
    }
  }
  
  @keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
  
    50% {
      stroke-dashoffset: 46.75;
      transform: rotate(135deg);
    }
  
    100% {
      stroke-dashoffset: 187;
      transform: rotate(450deg);
    }
  }

  // secondary loader styling
  .loader-container {
        display: flex;
        align-items: center;
    }
    .loader {
        display: flex;
    }
    .loader-text {
        margin-right: 12px;
        font-size: 16px;
        color: #333;
    }
    .dot {
        background-color: #3498DB;
        border-radius: 50%;
        animation: bounce 1.4s infinite ease-in-out;
    }
    .dot:nth-child(1) {
        animation-delay: 0s;
    }
    .dot:nth-child(2) {
        animation-delay: 0.2s;
    }
    .dot:nth-child(3) {
        animation-delay: 0.4s;
    }
    @keyframes bounce {
        0%, 80%, 100% {
            transform: translateY(0);
            opacity: 0.6;
        }
        40% {
            transform: translateY(-10px);
            opacity: 1;
        }
    }

    // spinner styling
  .spinner-loader {
    border: 3px solid #626F86;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  .spinner-loader::after {
    content: '';  
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    background: #FF3D00;
    width: 10px;
    height: 10px;
    transform: translate(-50%, 50%);
    border-radius: 50%;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  } 
  `,
})
export class LoaderComponent {
  private sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);

  isLoading = false;
  kindOfLoader: KindOfLoader = 'primary';
  @Input() secondaryLoaderDotSize!: string;
  @Input() secondaryLoaderDotGap!: string;

  ngOnInit(): void {
    this.sharedService.loader$.subscribe({
      next: (value) => {
        this.isLoading = value.isLoading;
        this.kindOfLoader = value.kind;
        this.cdr.detectChanges();
      },
    });
  }
}
